/*

THIS REDUCER IS USED TO TRACK PAYMENT

*/

import * as types from '../actions/actionTypes';

export const paymentStatusReducer = (state = {startPaymentProcessing: false, paymentSuccessful: false, billingAsShipping: true,}, action) => {
    var newState = { ...state }
    switch (action.type) {
        case types.SET_PAYMENT_STATUS:
            let fieldsLength = action.payload.length;
            for (let i = 0; i < fieldsLength; i++) {
              const data = action.payload[i];
              newState[data.fieldToUpdate] = data.value;
            }
            return newState;
            break;
        default:
            return state;
    }
}
